////////////////////////////////////////////////////////////
//     							                          //
//  Program: OwnershipType.jsx                            //
//  Application: Property                                 //
//  Option: to view Ownership Type                        //
//  Developer: NP  						                  //
//  Date: 2022-01-10                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Table, Modal, Form } from "react-bootstrap";
// import deleteicon from "../../assets/images/delete.svg";
import modaldeleteicon from "./../../assets/images/delete.svg";
import OwnershipTypeService from "../../services/OwnershipTypeService";
import SimpleReactValidator from "simple-react-validator";

import Alerts from "../common/Alerts";
// import pluswIcon from "./../../assets/images/plus.svg";
import { Container } from "react-bootstrap";
import MasterSidebar from "../common/MasterSidebar";
import NoData from "../common/NoData";

export class OwnershipType extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      open: global.showOpen,
      eventKey: "",
      input: {},
      errors: {},
      toggleSwitchDark2: true,
      status_id: true,
      slug: "",
      //for ownership type
      addOwnershipTypeModal: false,
      editOwnershipTypeModal: false,
      deleteOwnershipTypeModal: false,
      OwnershipTypeList: [],
      OwnershipTypeListTotal: 0,
      ownership_type_name: "",
      sort_order: "",
    };
    this.changeHandler = this.changeHandler.bind(this);
    //for ownership type
    this.openAddOwnershipTypeModal = this.openAddOwnershipTypeModal.bind(this);
    this.openEditOwnershipTypeModal =
      this.openEditOwnershipTypeModal.bind(this);
    this.openDeleteOwnershipTypeModal =
      this.openDeleteOwnershipTypeModal.bind(this);
    this.saveOwnershipType = this.saveOwnershipType.bind(this);
    this.getOwnershipTypeDetails = this.getOwnershipTypeDetails.bind(this);
    this.updateOwnershipType = this.updateOwnershipType.bind(this);
    this.deleteOwnershipType = this.deleteOwnershipType.bind(this);
  }

  componentDidMount() {
    this.getOwnershipTypeData();
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  closeModal() {
    this.setState({ showAlertModal: false });
  }

  setOpen(open, e) {
    this.setState({ open: open });
    this.setState({ eventKey: e.target.id });
    const scrollId = document.getElementById(e.target.id);
    scrollId.scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "start",
    });
  }

  /* to get ownership type data */
  async getOwnershipTypeData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var OwnershipTypeList = [];
    var OwnershipTypeListTotal = 0;

    let res = await OwnershipTypeService.getOwnership(
      queryString ? "&" + queryString : ""
    );
    if (global.successStatus.includes(res.status)) {
      OwnershipTypeList = res.data.data ? res.data.data : [];
      OwnershipTypeListTotal = OwnershipTypeList ? OwnershipTypeList.length : 0;
    }
    this.setState({
      OwnershipTypeList: OwnershipTypeList,
      OwnershipTypeListTotal: OwnershipTypeListTotal,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  /* to save ownership type data */
  saveOwnershipType = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.ownership_type_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        ownership_type_name: this.state.ownership_type_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await OwnershipTypeService.createOwnership(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeAddOwnershipTypeModal();
        this.setState({
          ownership_type_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getOwnershipTypeData();
      } else {
        //let alertMessage = "";
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.result.errorDetail[0].errorMessage
        //     ? res.data.result.errorDetail[0].errorMessage
        //     : "Error!",
        //   alertModalMessage:
        //     alertMessage !== "" ? alertMessage : res.data.errorMessage,
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* To get ownership type details data */
  async getOwnershipTypeDetails(slug) {
    this.setState({ showSpinner: true, isSubmit: true });
    if (slug) {
      var resData = {};
      let res = await OwnershipTypeService.getOwnershipBySlug(slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resData.ownership_type_name = res.data.ownership_type_name
          ? res.data.ownership_type_name
          : "";
        resData.sort_order = res.data.sort_order ? res.data.sort_order : "";
        resData.status_id = res.data.status_id === 1 ? true : false;
      }
      this.setState(resData);
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  /* to update ownership type data */
  updateOwnershipType = async (e) => {
    e.preventDefault();
    if (
      this.customValidate() &&
      !this.validator.errorMessages.ownership_type_name &&
      !this.validator.errorMessages.sort_order
    ) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        ownership_type_name: this.state.ownership_type_name,
        sort_order: this.state.sort_order,
        status_id: this.state.status_id === true ? 1 : 2,
      };

      let res = await OwnershipTypeService.updateOwnership(
        this.state.slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        this.closeEditOwnershipTypeModal();
        this.setState({
          ownership_type_name: "",
          status_id: true,
          sort_order: "",
        });
        this.getOwnershipTypeData();
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        // this.setState({
        //   showAlertModal: true,
        //   alertModalType: "error",
        //   alertModalTitle: res.data.result.errorDetail[0].errorMessage
        //     ? res.data.result.errorDetail[0].errorMessage
        //     : "Error!",
        //   alertModalMessage: res.data.message ? res.data.message : "Error!",
        // });
      }
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };

  /* to delete ownership type data */
  async deleteOwnershipType(slug) {
    this.setState({ showSpinner: true });
    let res = await OwnershipTypeService.deleteOwnership(slug);
    if (global.successStatus.includes(res.status)) {
      this.closeDeleteOwnershipTypeModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });

      this.getOwnershipTypeData();
    } else {
      this.closeDeleteOwnershipTypeModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ showSpinner: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  openAddOwnershipTypeModal() {
    this.setState({ addOwnershipTypeModal: true });
  }

  closeAddOwnershipTypeModal() {
    this.setState({ addOwnershipTypeModal: false });
    this.setState({
      ownership_type_name: "",
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openEditOwnershipTypeModal(slug) {
    this.getOwnershipTypeDetails(slug);
    this.setState({ editOwnershipTypeModal: true });
    this.setState({ slug: slug });
  }

  closeEditOwnershipTypeModal() {
    this.setState({ editOwnershipTypeModal: false });
    this.setState({
      slug: "",
      ownership_type_name: "",
      sort_order: "",
      status_id: true,
      errors: "",
    });
    this.validator.hideMessages();
  }

  openDeleteOwnershipTypeModal(slug) {
    this.setState({ deleteOwnershipTypeModal: true });
    this.setState({ slug: slug });
  }

  closeDeleteOwnershipTypeModal() {
    this.setState({ deleteOwnershipTypeModal: false });
    this.setState({ slug: "" });
  }

  getTitle() {
    return "Ownership Type";
  }

  render() {
    return (
      <>
        {/* <Card>
          <Card.Header>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="32"
              id="32"
              onClick={(e) => this.setOpen(!this.state.open, e)}
            >
              Ownership Type
              <i className="mdi mdi-view-headline"> </i>
              {this.state.open && this.state.eventKey === "32" ? (
                <i className="fas fa-chevron-down"></i>
              ) : (
                <i className="fas fa-chevron-up"></i>
              )}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="32">
            <Card.Body>
              <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
                <Button
                  variant="outline-dark btn-block btn-with-icon"
                  onClick={this.openAddOwnershipTypeModal}
                >
                  <img src={pluswIcon} /> Add
                </Button>
              </div>
              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                />
              </div>
              <div className="table-responsive">
                <Table hover className="mg-b-0">
                  <thead>
                    <tr>
                      <th className="w-50">Ownership Type Name</th>
                      <th className="w-25">Status</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.OwnershipTypeListTotal > 0 ? (
                      this.state.OwnershipTypeList.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td className="hand-cursor" onClick={() =>
                              this.openEditOwnershipTypeModal(item.slug)
                            }>{item.ownership_type_name}</td>
                            <td>
                              {item.status_id === 1 ? (
                                <b className="active"></b>
                              ) : (
                                <b></b>
                              )}
                            </td>
                            <td>
                              <div className="btn-icon-list d-block text-center">
                                <img
                                  src={deleteicon}
                                  alt="Delete"
                                  onClick={() =>
                                    this.openDeleteOwnershipTypeModal(item.slug)
                                  }
                                  className="hand-cursor"
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" align="center">
                          No rows found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card> */}

        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                  <div className="child-menu-section">
                    <aside>
                      <MasterSidebar />
                    </aside>
                  </div>
                </div>
                <div className="col-md-10 right settingsidebarNav">
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {/* {global.userPermissions.checkPermission(
                        "master-data-add"
                      ) && (
                        <Button
                          variant="outline-dark btn-block btn-with-icon"
                          onClick={this.openAddOwnershipTypeModal}
                        >
                          <img src={pluswIcon} /> Add
                        </Button>
                      )} */}
                      </div>
                    </div>
                  </div>
                  <div className="master">
                    <div className="table-responsive">
                      {/* <div className="row d-flex justify-content-end mg-r-0 mg-b-15">
              <Button
                variant="outline-dark btn-block btn-with-icon"
                onClick={this.openAddOwnershipTypeModal}
              >
                <img src={pluswIcon} /> Add
              </Button>
            </div> */}
                      <div className="col-md-12 pl-0 pr-0">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>
                      {this.state.OwnershipTypeListTotal > 0 ? (
                        <Table hover className="mg-b-0">
                          <thead>
                            <tr>
                              <th className="w-50">Ownership Type Name</th>
                              <th className="w-25">Status</th>
                              {/* {global.userPermissions.checkPermission(
                              "master-data-delete"
                            ) && (
                            <th className="text-center">Action</th>
                            )} */}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.OwnershipTypeListTotal > 0 ? (
                              this.state.OwnershipTypeList.map((item, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                    // className="hand-cursor"
                                    // onClick={() =>
                                    //   {global.userPermissions.checkPermission(
                                    //     "master-data-update"
                                    //   ) && ( this.openEditOwnershipTypeModal(item.slug) )}
                                    // }
                                    >
                                      {item.ownership_type_name}
                                    </td>
                                    <td>
                                      {item.status_id === 1 ? (
                                        <b className="active"></b>
                                      ) : (
                                        <b></b>
                                      )}
                                    </td>
                                    {/* {global.userPermissions.checkPermission(
                                    "master-data-delete"
                                  ) && (
                                  <td>
                                    <div className="btn-icon-list d-block text-center">
                                      <img
                                        src={deleteicon}
                                        alt="Delete"
                                        onClick={() =>
                                          this.openDeleteOwnershipTypeModal(
                                            item.slug
                                          )
                                        }
                                        className="hand-cursor"
                                      />
                                    </div>
                                  </td>
                                  )} */}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="9" align="center">
                                  There are no ownership types added in the
                                  system. You may add them by clicking Add
                                  button.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      ) : (
                        <NoData
                          msg={global.commonMessages.checkMessage(
                            "OWNERSHIPTYPE"
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* add ownership type popup modal */}
        <Modal
          show={this.state.addOwnershipTypeModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeAddOwnershipTypeModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeAddOwnershipTypeModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Add Ownership Type</h3>
            <label>Ownership Type</label>
            <Form.Control
              onChange={this.changeHandler}
              name="ownership_type_name"
              value={this.state.ownership_type_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Ownership Type"
            />
            {this.state.errors.ownership_type_name ? (
              <div className="text-danger">
                {this.state.errors.ownership_type_name}
              </div>
            ) : (
              this.validator.message(
                "ownership_type_name",
                this.state.ownership_type_name,
                "required|max:50",
                { className: "text-danger" }
              )
            )}

            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "numeric|min:0,num",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "Active" : "Inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeAddOwnershipTypeModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveOwnershipType}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* edit ownership type popup modal */}
        <Modal
          show={this.state.editOwnershipTypeModal}
          onHide={() => {
            if (window.confirm("Do you want to exit without saving?"))
              this.closeEditOwnershipTypeModal();
          }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeEditOwnershipTypeModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">Update Ownership Type</h3>
            <label>Ownership Type</label>
            <Form.Control
              onChange={this.changeHandler}
              name="ownership_type_name"
              value={this.state.ownership_type_name}
              className="form-control max_width_100"
              id="inlineFormInput"
              type="text"
              maxLength="50"
              autoComplete="off"
              // placeholder="Ownership Type"
            />
            {this.state.errors.ownership_type_name ? (
              <div className="text-danger">
                {this.state.errors.ownership_type_name}
              </div>
            ) : (
              this.validator.message(
                "ownership_type_name",
                this.state.ownership_type_name,
                "required|max:50",
                { className: "text-danger" }
              )
            )}
            {/* <InputGroup className="mt-3">
              <label>Sort Order</label>
              <Form.Control
                onChange={this.changeHandler}
                name="sort_order"
                value={this.state.sort_order}
                onKeyPress={global.onKeyPressEvent.numberValidation}
                className="form-control max_width_100"
                id="inlineFormInput"
                type="text"
                // placeholder="Sort Order"
              />
            </InputGroup>
            {this.state.errors.sort_order ? (
              <div className="text-danger">{this.state.errors.sort_order}</div>
            ) : (
              this.validator.message(
                "sort_order",
                this.state.sort_order,
                "integer",
                { className: "text-danger" }
              )
            )} */}

            <div className="d-flex align-items-center justify-content-end mt-3">
              <b className={this.state.status_id ? "active" : "inactive"}>
                {this.state.status_id ? "Active" : "Inactive"}
              </b>
              <div
                className={this.state.status_id ? "az-toggle on" : "az-toggle"}
                onClick={() =>
                  this.setState({ status_id: !this.state.status_id })
                }
              >
                <span></span>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeEditOwnershipTypeModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={this.updateOwnershipType}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Save"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete ownership type popup modal */}
        <Modal
          show={this.state.deleteOwnershipTypeModal}
          // onHide={() => {
          //   if (
          //     window.confirm("Are you sure to exit the pop up without delete?")
          //   )
          //     this.closeDeleteOwnershipTypeModal();
          // }}
          centered
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span
                className="welcomeClose"
                onClick={() => this.closeDeleteOwnershipTypeModal()}
              >
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="modal-delete-icon" />
              <h3>Delete the Option?</h3>
              <p>
                Do you really want to delete this option? This process cannot be
                undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteOwnershipTypeModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteOwnershipType(this.state.slug)}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default OwnershipType;
